import { render, staticRenderFns } from "./m_publicDemand.vue?vue&type=template&id=65e766d4&scoped=true"
import script from "./m_publicDemand.vue?vue&type=script&lang=js"
export * from "./m_publicDemand.vue?vue&type=script&lang=js"
import style0 from "./m_publicDemand.vue?vue&type=style&index=0&id=65e766d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e766d4",
  null
  
)

export default component.exports